import React from "react";
import cx from "classnames";
import { css } from "@linaria/core";
import { colors, fonts, spacings } from "../Theme";

function Tag_({
  children,
  theme = "light",
  size = "m",
  title,
  className,
}: React.PropsWithChildren<{
  theme?: "dark" | "light";
  size?: "s" | "m";
  className?: string;
  title?: string;
}>) {
  return (
    <div className={cx(tag, theme, size, className)} title={title}>
      {children}
    </div>
  );
}
export const Tag = React.memo(Tag_);

function Square_({ color = "black", size = "m" }: { color?: string; size?: "s" | "m" }) {
  return <div className={cx(square, size)} style={{ color }} />;
}
export const Square = React.memo(Square_);

const tag = css`
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  font: ${fonts.body1};
  gap: ${spacings.xxs};
  max-width: 100%;
  padding: ${spacings.xxs} ${spacings.xs};
  white-space: nowrap;
  overflow: hidden;

  > * {
    flex-shrink: 0;
    flex-grow: 1;
    flex-basis: 0%;
    max-width: max-content;
  }

  &.s /* size */ {
    font: ${fonts.body2};
  }

  &.light {
    background-color: ${colors.titanium100};
    color: ${colors.carbon800};
  }

  &.dark {
    background-color: rgba(233, 235, 241, 0.2);
    color: ${colors.carbon50};
  }
`;

const square = css`
  background-color: currentColor;
  border: 1px solid ${colors.hydrogen};
  border-radius: 1px;
  height: 12px;
  width: 12px;

  &.m {
    height: 16px;
    width: 16px;
  }
`;

export const tagList = css`
  display: flex;
  flex-wrap: nowrap;
  gap: ${spacings.xs};
  max-width: 100%;

  &:has(> *:nth-child(2)) > * {
    max-width: 50%;
  }
`;
